export const p_dict: { p: number[]; z: number[] } = {
    p: [
      0.5,
      0.48006119416162751,
      0.46017216272297101,
      0.4403823076297575,
      0.42074029056089696,
      0.4012936743170763,
      0.38208857781104733,
      0.3631693488243809,
      0.34457825838967582,
      0.32635522028791997,
      0.30853753872598688,
      0.29115968678834636,
      0.27425311775007355,
      0.25784611080586473,
      0.24196365222307303,
      0.22662735237686821,
      0.21185539858339669,
      0.19766254312269238,
      0.18406012534675947,
      0.17105612630848183,
      0.15865525393145707,
      0.14685905637589591,
      0.13566606094638267,
      0.12507193563715024,
      0.11506967022170828,
      0.10564977366685535,
      0.096800484585610358,
      0.088507991437401956,
      0.080756659233771066,
      0.073529259609648304,
      0.066807201268858071,
      0.060570758002059008,
      0.054799291699557974,
      0.049471468033648075,
      0.044565462758543006,
      0.040059156863817086,
      0.035930319112925789,
      0.032156774795613713,
      0.028716559816001783,
      0.025588059521638611,
      0.022750131948179195,
      0.020182215405704383,
      0.017864420562816542,
      0.015777607391090499,
      0.013903447513498595,
      0.012224472655044696,
      0.010724110021675795,
      0.0093867055348385662,
      0.0081975359245961138,
      0.0071428107352714152,
      0.0062096653257761323,
      0.0053861459540666843,
      0.0046611880237187467,
      0.0040245885427583027,
      0.0034669738030406647,
      0.0029797632350545551,
      0.002555130330427929,
      0.0021859614549132405,
      0.0018658133003840339,
      0.0015888696473648667,
      0.0013498980316300933,
      0.0011442068310226977,
      0.00096760321321835631,
      0.00081635231282856037,
      0.00068713793791584708,
      0.00057702504239076592,
      0.00048342414238377663,
      0.0004040578018640207,
      0.00033692926567687988,
      0.00028029327681617744,
      0.00023262907903552502,
      0.00019261557563563279,
      0.00015910859015753364,
      0.00013112015442048433,
      0.00010779973347738823,
      8.8417285200803773e-05,
      7.2348043925119787e-05,
      5.9058912418922374e-05,
      4.8096344017602614e-05,
      3.9075596597787456e-05,
      3.1671241833119863e-05,
      2.5608816474041489e-05,
      2.0657506912546683e-05,
      1.6623763729652213e-05,
      1.334574901590631e-05,
      1.0688525774934402e-05,
      8.5399054709917942e-06,
      6.8068765993340312e-06,
      5.4125439077038407e-06,
      4.293514469971858e-06,
      3.3976731247300535e-06,
      2.6822957796388472e-06,
      2.1124547025028419e-06,
      1.6596751443714555e-06,
      1.3008074539172771e-06,
      1.0170832425687032e-06,
      7.9332815197558919e-07,
      6.1730737200919249e-07,
      4.7918327659031855e-07,
      3.7106740796333271e-07,
      2.8665157187919333e-07,
      2.2090503226954194e-07,
      1.6982674071475937e-07,
      1.3024322953320117e-07,
      9.9644263169334701e-08,
      7.6049605164887e-08,
      5.7901340399645569e-08,
      4.3977115940058689e-08,
      3.3320448485428448e-08,
      2.518491005446105e-08,
      1.8989562465887681e-08,
      1.4283479893922661e-08,
      1.0717590258310852e-08,
      8.0223918506634739e-09,
      5.9903714010635304e-09,
      4.4621724539016108e-09,
      3.3157459783261365e-09,
      2.4578650618080152e-09,
      1.8175078630994235e-09,
      1.3407124440918662e-09,
      9.8658764503769458e-10,
      7.2422917051376055e-10,
      5.303423262948808e-10,
      3.8741473466756636e-10,
      2.8231580370432682e-10,
      2.0522634252189396e-10,
      1.4882282217622966e-10,
      1.0765746385121517e-10,
      7.7688475817097756e-11,
      5.592507575942645e-11,
      4.0160005838590881e-11,
      2.8768541736043109e-11,
      2.055788909399508e-11,
      1.4654650977302715e-11,
      1.0420976987965154e-11,
      7.3922577780177942e-12,
      5.2309575441445253e-12,
      3.6924994272355614e-12,
      2.600126965638173e-12,
      1.8264310619769611e-12,
      1.279812543885835e-12,
      8.9458895587698439e-13,
      6.23784446333152e-13,
      4.3388950271780343e-13,
      3.0106279811174218e-13,
      2.0838581586720548e-13,
      1.4388386381575764e-13,
      9.9103427495475088e-14,
      6.8092248906200155e-14,
      4.6670115887190274e-14,
      3.1908916729108844e-14,
      2.1762912097085575e-14,
      1.4806537490047908e-14,
      1.0048965656526223e-14,
      6.8033115407739012e-15,
      4.5946274357785623e-15,
      3.095358771958668e-15,
      2.0801863521393674e-15,
      1.394517146659261e-15,
      9.3255757716812045e-16,
      6.2209605742717405e-16,
      4.1397018162731219e-16,
      2.7479593923982212e-16,
      1.8196213635266084e-16,
      1.2019351542735647e-16,
      7.9197263146424757e-17,
      5.2055697448902465e-17,
      3.4131483264581459e-17,
      2.232393197288031e-17,
      1.456514112590909e-17,
      9.4795348222032499e-18,
      6.1544255908503949e-18,
      3.985804962848151e-18,
      2.5749715380118873e-18,
      1.6594208699647519e-18,
      1.0667637375474856e-18,
      6.840807685935497e-19,
      4.3759647993090167e-19,
      2.7923343749396233e-19,
      1.7774117841455144e-19,
      1.1285884059538324e-19,
      7.1484170112696837e-20,
      4.516591491435403e-20,
      2.8466774084602088e-20,
      1.7897488120140146e-20,
      1.1224633591327901e-20,
      7.0222842404415411e-21,
      4.3823862990664603e-21,
      2.7281535713460872e-21,
      1.6941535024881097e-21,
      1.0494515075362604e-21,
      6.4848144530772079e-22,
      3.9972212057261192e-22,
      2.4577864834723153e-22,
      1.5074931688101589e-22,
      9.2234135249393526e-23,
      5.6292823113765143e-23,
      3.4271987941135974e-23,
      2.0813752194932085e-23,
      1.2609160670206559e-23
    ],
    z: [
      0.0,
      0.050000000000000003,
      0.10000000000000001,
      0.15000000000000002,
      0.20000000000000001,
      0.25,
      0.30000000000000004,
      0.35000000000000003,
      0.40000000000000002,
      0.45000000000000001,
      0.5,
      0.55000000000000004,
      0.60000000000000009,
      0.65000000000000002,
      0.70000000000000007,
      0.75,
      0.80000000000000004,
      0.85000000000000009,
      0.90000000000000002,
      0.95000000000000007,
      1.0,
      1.05,
      1.1000000000000001,
      1.1500000000000001,
      1.2000000000000002,
      1.25,
      1.3,
      1.3500000000000001,
      1.4000000000000001,
      1.4500000000000002,
      1.5,
      1.55,
      1.6000000000000001,
      1.6500000000000001,
      1.7000000000000002,
      1.75,
      1.8,
      1.8500000000000001,
      1.9000000000000001,
      1.9500000000000002,
      2.0,
      2.0500000000000003,
      2.1000000000000001,
      2.1499999999999999,
      2.2000000000000002,
      2.25,
      2.3000000000000003,
      2.3500000000000001,
      2.4000000000000004,
      2.4500000000000002,
      2.5,
      2.5500000000000003,
      2.6000000000000001,
      2.6500000000000004,
      2.7000000000000002,
      2.75,
      2.8000000000000003,
      2.8500000000000001,
      2.9000000000000004,
      2.9500000000000002,
      3.0,
      3.0500000000000003,
      3.1000000000000001,
      3.1500000000000004,
      3.2000000000000002,
      3.25,
      3.3000000000000003,
      3.3500000000000001,
      3.4000000000000004,
      3.4500000000000002,
      3.5,
      3.5500000000000003,
      3.6000000000000001,
      3.6500000000000004,
      3.7000000000000002,
      3.75,
      3.8000000000000003,
      3.8500000000000001,
      3.9000000000000004,
      3.9500000000000002,
      4.0,
      4.0499999999999998,
      4.1000000000000005,
      4.1500000000000004,
      4.2000000000000002,
      4.25,
      4.2999999999999998,
      4.3500000000000005,
      4.4000000000000004,
      4.4500000000000002,
      4.5,
      4.5499999999999998,
      4.6000000000000005,
      4.6500000000000004,
      4.7000000000000002,
      4.75,
      4.8000000000000007,
      4.8500000000000005,
      4.9000000000000004,
      4.9500000000000002,
      5.0,
      5.0500000000000007,
      5.1000000000000005,
      5.1500000000000004,
      5.2000000000000002,
      5.25,
      5.3000000000000007,
      5.3500000000000005,
      5.4000000000000004,
      5.4500000000000002,
      5.5,
      5.5500000000000007,
      5.6000000000000005,
      5.6500000000000004,
      5.7000000000000002,
      5.75,
      5.8000000000000007,
      5.8500000000000005,
      5.9000000000000004,
      5.9500000000000002,
      6.0,
      6.0500000000000007,
      6.1000000000000005,
      6.1500000000000004,
      6.2000000000000002,
      6.25,
      6.3000000000000007,
      6.3500000000000005,
      6.4000000000000004,
      6.4500000000000002,
      6.5,
      6.5500000000000007,
      6.6000000000000005,
      6.6500000000000004,
      6.7000000000000002,
      6.75,
      6.8000000000000007,
      6.8500000000000005,
      6.9000000000000004,
      6.9500000000000002,
      7.0,
      7.0500000000000007,
      7.1000000000000005,
      7.1500000000000004,
      7.2000000000000002,
      7.25,
      7.3000000000000007,
      7.3500000000000005,
      7.4000000000000004,
      7.4500000000000002,
      7.5,
      7.5500000000000007,
      7.6000000000000005,
      7.6500000000000004,
      7.7000000000000002,
      7.75,
      7.8000000000000007,
      7.8500000000000005,
      7.9000000000000004,
      7.9500000000000002,
      8.0,
      8.0500000000000007,
      8.0999999999999996,
      8.1500000000000004,
      8.2000000000000011,
      8.25,
      8.3000000000000007,
      8.3499999999999996,
      8.4000000000000004,
      8.4500000000000011,
      8.5,
      8.5500000000000007,
      8.5999999999999996,
      8.6500000000000004,
      8.7000000000000011,
      8.75,
      8.8000000000000007,
      8.8499999999999996,
      8.9000000000000004,
      8.9500000000000011,
      9.0,
      9.0500000000000007,
      9.0999999999999996,
      9.1500000000000004,
      9.2000000000000011,
      9.25,
      9.3000000000000007,
      9.3499999999999996,
      9.4000000000000004,
      9.4500000000000011,
      9.5,
      9.5500000000000007,
      9.6000000000000014,
      9.6500000000000004,
      9.7000000000000011,
      9.75,
      9.8000000000000007,
      9.8500000000000014,
      9.9000000000000004,
      9.9500000000000011
    ]
  };